<template>
<div>
    <div v-if="!moreStatus">
        <el-carousel :height="bannerHeight + 'px'" :interval="2000" :autoplay="true">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img" style="width:100%;" ref="bannerHeight" width="100%" @load="imgLoad">
            </el-carousel-item>
        </el-carousel>
        <div :style="{backgroundImage: 'url('+bgImage+')'}" style="width: 100%;margin-top:80px;background-position: center top;background-repeat: no-repeat;background-size: cover;">
            <!-- <div class="parallel"></div> -->
            <div style="width:80%;margin:0 auto;margin-top:20px;display:flex;">
                <img style="width:52%;" src="../assets/toujiao1.jpg"/>
                <div style="margin-left:5%;width:42%;padding:30px 20px;display:flex;align-items: center;">
                    <div>
                        <div style="font-size:20px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">第一进
                            <img style="width:24px;margin-left:6px;" src="../assets/sangang2.png" >
                        </div>
                        <div style="font-size:48px;font-weight:600;margin-top:10px;">百年蒋氏展厅</div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:10px;">——清雅古居开篇金融传承</div>
                        <div style="font-size:20px;margin-top:30px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">一百五十年的蒋寿山故居像一位跨越时空的历史老人，讲述着金</div>
                        <div style="font-size:20px;margin-top:15px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">陵蒋氏勤劳致富、积德行善、人才辈出、奉献社会的故事......</div>
                        <div style="margin-top:34px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width:92%;margin:0 auto;margin-left:8%;display:flex;margin-top: 170px;">
                <div style="width:40%;margin-left:2%;text-align:left;padding-top:110px;">
                    <div>
                        <div style="font-size:20px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">第二进
                            <img style="width:24px;margin-left:6px;" src="../assets/sangang2.png" >
                        </div>
                        <div style="font-size:48px;font-weight:600;margin-top:10px;">中西方金融史展厅</div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:10px;">——西方/中国金融基因“一脉相承”</div>
                        <div style="font-size:20px;margin-top:40px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">穿越一千多年中西方金融史长河，重点展陈西方及中国近代的金</div>
                        <div style="font-size:20px;margin-top:15px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">融发展，再现经典的金融人物故事和风险事件，启示后人，彰显</div>
                        <div style="font-size:20px;margin-top:15px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">金融基因的传承。</div>
                        <div style="margin-top:34px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
                <img style="width:55%;margin-left:1%;" src="../assets/toujiao2.jpg"/>
            </div>
            <div style="width:86%;margin:0 auto;display:flex;margin-top: 86px;">
                <img style="width:30%;margin-left:5%;padding-top:50px;" src="../assets/toujiao3.jpg"/>
                <div style="margin-left:10%;width:53%;display:flex;align-items: center;">
                    <div>
                        <div style="font-size:20px;font-family:Microsoft YaHei;color:#333333;font-weight:400;">第三进
                            <img style="width:24px;margin-left:6px;" src="../assets/sangang2.png" >
                        </div>
                        <div style="font-size:46px;font-weight:700;margin-top:10px;">投教互动与成果展示厅</div>
                        <div style="font-size:36px;color:#000000;margin-top:10px;">——与金融市场相互赋能 形成正向的循环</div>
                        <div style="font-size:19px;margin-top:30px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">走进中国证券发展史，见证资本市场的发展演化；在投资者适当性专区，体验趣味</div>
                        <div style="font-size:19px;margin-top:15px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">生动的投教互动；走进投教成果展示区，让参观者沉浸式参与投教。</div>
                        <div style="margin-top:30px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width:86%;margin:0 auto;margin-top: 30px;text-align:center;position:relative;">
                <img style="width:65%;" src="../assets/toujiao4.jpg"/>
                <!-- <img style="width:30%;position:absolute;top:-50px;right:8%;" src="../assets/huishengdongtai1.png"/> -->
            </div>

            <div style="width:90%;margin:0 auto;margin-left:10%;display:flex;margin-top: 91px;">
                <div style="width:40%;margin-left:2%;text-align:left;padding-top:120px;">
                    <div>
                        <div style="font-size:20px;">后四进
                            <img style="width:24px;margin-left:6px;" src="../assets/sangang2.png" >
                        </div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:10px;">——投教运营功能区</div>
                        <div style="font-size:20px;margin-top:20px;font-family:Microsoft YaHei;color:#000000;font-weight:500;">投教基地后四进为主要功能区，集金融专业人大代表联络站，智善</div>
                        <div style="font-size:20px;margin-top:15px;font-family:Microsoft YaHei;color:#000000;font-weight:500;">金融研究院、投教直播间、投教培训中心等功能于一体，为金融投</div>
                        <div style="font-size:20px;margin-top:15px;font-family:Microsoft YaHei;color:#000000;font-weight:500;">教源源不断地提供创意作品和智库支持。</div>
                        <div style="margin-top:33px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
                <img style="width:61%;margin-top:10px;margin-left:1%;" src="../assets/toujiao8.jpg"/>
            </div>

            <div style="width:80%;margin-top: 10px;position:relative;">
                <img style="width:70%;margin-left:10%;margin-top:-10%;" src="../assets/toujiao5.jpg"/>
                <!-- <img style="width:30%;position:absolute;top:-100px;left:8%;" src="../assets/huishengdongtai1.png"/> -->
            </div>

            <!-- <div style="width:90%;margin:0 auto;display:flex;margin-top: 80px;">
                <div style="width:43%;margin-left:2%;text-align:left;padding-top:50px;">
                    <div>
                        <div style="font-size:14px;">后四进</div>
                        <div style="font-size:23px;font-weight:600;color:#92dded;margin-top:10px;">————投教运营功能区</div>
                        <div style="font-size:14px;margin-top:20px;">投教基地后四进为主要功能区，集金融专业人大代表联络站，智善</div>
                        <div style="font-size:14px;margin-top:10px;">金融研究院、投教直播间、投教培训中心等功能于一体，为金融投</div>
                        <div style="font-size:14px;margin-top:10px;">教源源不断地提供创意作品和智库支持。</div>
                    </div>
                </div>
                <img style="width:53%;margin-left:3%;" src="../assets/huishengdongtai1.png"/>
            </div> -->
            <!-- <div style="width:90%;">
                <img style="width:45%;margin-top:-60px;transform: translateX(30%);" src="../assets/huishengdongtai1.png"/>
            </div>
            <div style="width:90%;text-align:right;">
                <img style="width:45%;margin-top:-60px;transform: translateX(0%);" src="../assets/huishengdongtai1.png"/>
            </div> -->
            <div style="width:86%;margin:0 auto;margin-top:120px;display:flex;">
                <img style="width:50%;" src="../assets/toujiao66.jpg"/>
                <div style="width:45%;margin-left:3%;padding:30px;display:flex;">
                    <div>
                        <div style="font-size:58px;font-weight:600;margin-top:20px;">四大投教主题活动</div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:36px;">1. 国民教育话理财</div>
                        <div style="font-size:20px;margin-top:20px;font-family:Microsoft YaHei;color:#000000;font-weight:500;">持续推进投教纳入国民教育体系，为广大在校学生普及金融知识，</div>
                        <div style="font-size:20px;margin-top:20px;font-family:Microsoft YaHei;color:#000000;font-weight:500;">提升金融素养。</div>
                        <div style="margin-top:39px;height:40px;line-height:40px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
            </div>

            <div style="width:80%;margin:0 auto;margin-left:12%;display:flex;margin-top: -5%;">
                <div style="width:40%;margin-left:2%;text-align:left;padding-top:50px;display: flex;align-items: end;">
                    <div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:10px;">2. 百家社区解骗局</div>
                        <div style="font-size:20px;margin-top:20px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">积极走进社区，通过专题讲座、寓教于乐的比赛等多种形式，提升社区居民金融风险意识。</div>
                        <div style="margin-top:34px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
                <img style="width:43%;margin-left:3%;" src="../assets/toujiao77.jpg"/>
            </div>

            <div style="width:80%;margin:0 auto;margin-left:15%;margin-top:82px;display:flex;">
                <img style="width:50%;" src="../assets/toujiao9.jpg"/>
                <div style="width:45%;margin-left:3%;padding:30px;display:flex;">
                    <div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:20px;">3. 大咖云集讲金融</div>
                        <div style="font-size:20px;margin-top:20px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">定期邀请国内外金融大咖开展专题讲座，凝心汇智，聚善公益。</div>
                        <div style="margin-top:34px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
            </div>

            <div style="width:82%;margin-left:18%;display:flex;margin-top: -8%;padding-bottom:120px;">
                <div style="width:40%;margin-left:1%;text-align:left;padding-top:50px;display: flex;align-items: center;">
                    <div>
                        <div style="font-size:38px;font-weight:600;color:#3fa8c7;margin-top:10px;">4. 镕古铸今释投教</div>
                        <div style="font-size:20px;margin-top:20px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">每年举办“蒋百万”杯金融投教大赛，结合投教基地文</div>
                        <div style="font-size:20px;margin-top:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">史传承的特点，以金融投教为主题，紧密围绕历史给当</div>
                        <div style="font-size:20px;margin-top:10px;font-family:Microsoft YaHei;color:#000000;font-weight:400;">代金融投教带来的启示展开。</div>
                        <div style="margin-top:34px;">
                            <img style="width:32px;" src="../assets/juxing1.png"/>
                            <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                            <img style="width:32px;" src="../assets/juxing3.png"/>
                        </div>
                    </div>
                </div>
                <img style="width:59%;margin-left:0%;" src="../assets/toujiao13.jpg"/>
            </div>
        </div>
        <div class="solve head-label just_center" style="padding-top: 30px;">
            <img style="width:34px;" src="../assets/sangang1.png" >
            <div style="text-align: center;cursor:pointer;margin-left:20px;margin-right:20px;font-size:32px;font-weight:600;" class="font_size_24">
                汇升投研
            </div>
            <img style="width:34px;" src="../assets/sangang2.png" >
        </div>
        <div style="margin: 0 auto;margin-top:33px;width: 160px;height:46px;border-radius:23px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
            <div @click="handleMore" style="font-size:15px;font-weight:600;text-align:center;border-radius:20px;background:#3fa8c7;color:#ffffff;width:150px;height:40px;line-height:40px;cursor:pointer;">全部动态
                <img style="vertical-align: middle;" src="../assets/jiantou.png"/>
            </div>
        </div>
        <!-- <div style="width:90%;margin:0 auto;margin-top:60px;padding-bottom:50px;display:flex;justify-content: space-around;">
            <img style="width:25%;" src="../assets/toujiao11.jpg"/>
            <img style="width:25%;" src="../assets/toujiao10.jpg"/>
            <img style="width:25%;" src="../assets/toujiao12.jpg"/>
        </div> -->
        <div style="width:90%;margin:0 auto;margin-top:60px;padding-bottom:50px;display:flex;justify-content: space-around;">
            <!-- <img style="width:25%;cursor:pointer;" v-for="item in trends0" :key="item.imgId" :src="getImgUrl(item.imgId)" @click="jumpWX(item)"/> -->
            <div style="width:25%;cursor:pointer;position:relative;display: flex;justify-content: center;align-items: center;" v-for="item in trends0" :key="item.imgId" @click="jumpWX(item)">
                <img style="width:100%;" :src="getImgUrl(item.imgId)"/>
                <div style="position: absolute;width: 100%;top:0;left:0;height: 100%;background: linear-gradient(to right, #003c82, #46434c);opacity: .3;"></div>
                <div style="position:absolute;top:45%;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:16px;">{{item.title}}</div>
                <div style="clear:both;"></div>
                <!-- <div style="position:absolute;top:40%;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:16px;">{{item.title}}</div> -->
            </div>
        </div>
    </div>
    <div v-if="moreStatus" style="width:82%;margin: 0 auto;padding-top:40px;">
        <div style="position:relative;font-size: 32px;font-weight:600;padding-bottom:15px;border-bottom: 1px solid #92dded;">
            汇升投研
            <img style="width:34px;margin-left:8px;" src="../assets/sangang2.png" >

            <div style="position:absolute;right:20px;top:5px;">
                <img style="width:32px;" src="../assets/juxing3.png"/>
                <img style="width:32px;" src="../assets/juxing1.png"/>
                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                <img style="width:32px;" src="../assets/juxing3.png"/>
            </div>
        </div>
        <div style="display: flex;margin-top:20px;border-bottom:1px solid #e8eaed;padding-bottom:18px;cursor:pointer;" v-for="item in trends" @click="jumpWX(item)" :key="item">
            <div style="width:30%;">
                <img style="width:90%;" :src="getImgUrl(item.imgId)"/>
            </div>
            <div style="width:70%;">
                <div style="font-size:23px;font-weight:600;margin-top:15px;">
                    {{item.title}}
                </div>
                <div style="font-size:16px;color:#3fa8c7;margin-top:15px;">发布于：{{item.createdTime}}</div>
                <div style="font-size:16px;margin-top:30px;">{{item.content}}</div>
            </div>
        </div>
        <el-pagination
            style="margin-top:15px;text-align:center;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout=" prev, pager, next"
            :total="totalNum">
        </el-pagination>
    </div>
</div>
</template>
<script>
import { articleList } from '@/api/index'
    export default {
        name: 'Index',
        data() {
            return {
                bgImage: require('../assets/toujiao_bg.png'),
                sliders: [],
                bannerHeight: '',
                moreStatus: false,
                titles: [{
                    name: '首页',
                    value: '/index'
                }, {
                    name: '走进汇升',
                    value: '/enterHS'
                }, {
                    name: '汇升文化',
                    value: '/hsCulture'
                }, {
                    name: '汇升投教',
                    value: '/hsInvestEducation'
                }, {
                    name: '汇升招聘',
                    value: '/hsEngage'
                }],
                locationUrl: 'http://www.hhhstz.com' + '/website_service/img/preview/',
                trends: [],
                trends0: [],
                currentPage: 1, //默认显示第一页
                pageSize: 5, //默认每页显示10条
                totalNum: 0, //总页数
                carousel_height: '550px',
            }
        },
        methods: {
            changeTitle(item) {
                this.$router.push({
                    path: item.value,
                    // query: {
                    //     id: this.roleId,
                    //     ids: this.checkList
                    // }
                })
            },
            handleMore() {
                this.moreStatus = true
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 10)
            },
            imgLoad() {
                this.$nextTick(() => {
                    this.bannerHeight = this.$refs.bannerHeight[0].height
                })
            },
            getImgUrl(id) {
                return this.locationUrl + id
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val; //动态改变
            },
            jumpWX(item) {
                // console.log(item)
                if (item.linkUrl) {
                    // location.href = item.linkUrl
                    window.open(item.linkUrl, "_blank");
                }
            },
            handleCurrentChange(val) {
                this.currentPage = val; //动态改变
                this.initData()

                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 10)
            },
            initData() {
                articleList({
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    type: 1
                })
                .then(res => {
                    this.trends = res.data.records
                    
                    this.totalNum = res.data.sumCount
                })

                articleList({
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    type: 1,
                    focus: 1
                })
                .then(res => {
                    this.trends0 = res.data.records
                    // this.trends = res.data.records
                    // if (this.trends.length > 3) {
                    //     this.trends0 = this.trends.slice(0, 3)
                    // } else {
                    //     this.trends0 = this.trends
                    // }
                    
                    // this.totalNum = res.data.sumCount
                })
            }
        },
        mounted() {
            this.initData()
            this.imgLoad()
            this.sliders = [
                {
                    img: require("../assets/banner3-1.jpg")
                },
                {
                    img: require("../assets/banner3-2.jpg")
                },
                {
                    img: require('../assets/banner3-3.jpg')
                },
                {
                    img: require('../assets/banner3-4.jpg')
                },
                {
                    img: require('../assets/banner3-5.jpg')
                }
            ]

            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 10)
        },
        computed: {

        },
    }
</script>
<style scoped>
.just_center {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/hsInvestEducation.vue